import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { apiUrl } from "../../config/config";

export const useGetOptionAccessories = () => {
  const fn = async () => {
    const { data } = await axios.get(`${apiUrl}/acc/v1/options/display`);

    return data;
  };

  return useQuery(["options/accessories"], fn);
};
